import Header from '../components/Header';
// import Billing from '../components/Loading';
import Sidebar from '../components/Sidebar';
import SummaryBtns from '../components/SummaryBtns';

export default function Dashboard() {
	return (
		<div className="flex flex-col h-screen">
			<Header />
			<div className="flex flex-1 overflow-hidden">
				<Sidebar />
				<main className="flex-1 overflow-y-auto bg-slate-50">
					<SummaryBtns />
				</main>
			</div>
		</div>
	);
}
